import { nanoid } from '@reduxjs/toolkit';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { useAccount, useCreateTournament, useTournaments } from '~/apis';
import Link from '~/components/Link';
import { LeagueType } from '~/server/src/dtos';
import { refreshTournaments } from '~/setup/actions';
import { cn } from '~/utils/styles';
interface TournamentControlsProps {
  className?: string;
}

const TournamentControls = ({ className }: TournamentControlsProps): JSX.Element => {
  const dispatch = useDispatch();
  const createTournament = useCreateTournament();
  const { data: account } = useAccount();

  const tournaments = useTournaments();
  const [isLeagueTouched, setIsLeagueTouched] = useState(false);

  const [request, setRequest] = useState(() => {
    return {
      name: `Debug Turnier ${nanoid(6)}`,
      description: 'Aufregend. Schnell. Purer Nervenkitzel - So geht Turfmaster.',
      lobbyOpenTimeDiff: 10,
      tournamentLeague: LeagueType.Silver,
    };
  });

  const tournamentLeague =
    !isLeagueTouched && account?.toplistLeague ? account.toplistLeague : request.tournamentLeague;

  return (
    <div className={cn('mb-4 flex flex-col space-y-2', className)}>
      <div>{`Anzahl angelegter Turniere: ${tournaments?.data?.length}`}</div>

      <label>
        Name
        <input
          type="text"
          value={request.name}
          onChange={({ target: { value } }) =>
            setRequest((request) => ({ ...request, name: value }))
          }
        />
      </label>

      <label>
        Zeit zwischen Join und Start
        <input
          type="number"
          value={request.lobbyOpenTimeDiff}
          onChange={({ target: { value } }) =>
            setRequest((request) => ({ ...request, lobbyOpenTimeDiff: Number.parseInt(value) }))
          }
        />
      </label>

      <label>
        Turniertyp
        <select
          value={tournamentLeague}
          onChange={({ target: { value } }) => {
            setIsLeagueTouched(true);
            setRequest((request) => ({ ...request, tournamentLeague: value as LeagueType }));
          }}
        >
          {Object.values(LeagueType).map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>
      </label>

      <Link
        underline="hover"
        className="cursor-pointer"
        onClick={() => {
          const now = new Date().getTime();
          const firstTime = now + 20 * 1000;
          const secondTime = firstTime + request.lobbyOpenTimeDiff * 1000 + 20 * 1000;
          const startingTimes = [
            new Date(firstTime).toISOString(),
            new Date(secondTime).toISOString(),
          ];
          createTournament.mutate(
            { ...request, tournamentLeague, startingTimes },
            {
              onSuccess: () => {
                dispatch(refreshTournaments());
                void tournaments.refetch();
              },
            },
          );
        }}
      >
        Erstelle Turnier (startet sofort)
      </Link>
    </div>
  );
};

export default TournamentControls;
